export default __webpack_public_path__ + "static/media/FB.985a94b1.svg";